import React from 'react';

const SellerServices = () => {
    return (
        <div>
            <h1>SellerServices page</h1>
        </div>
    );
}

export default SellerServices;
